(function(angular, module) {var dybFormArrayController, dybFormSortableController, dybSubFormController, findParent,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  hasProp = {}.hasOwnProperty,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

findParent = function(element, names) {
  var controller, j, len, name, parent;
  if (names == null) {
    names = ["dybSubForm", "dybFormArray", "dybFormSortable", "dybForm"];
  }
  parent = element.parent();
  for (j = 0, len = names.length; j < len; j++) {
    name = names[j];
    controller = parent.controller(name);
    if (controller != null) {
      return controller;
    }
  }
  return null;
};

dybSubFormController = (function() {
  dybSubFormController.prototype.directiveName = 'dybSubForm';


  /* @ngInject */

  function dybSubFormController($scope, $element, $attrs, $parse) {
    this.$destroy = bind(this.$destroy, this);
    var exp;
    this.ngForm = $element.controller('form');
    this.dybForm = $element.controller('dybForm');
    this.parent = findParent($element);
    this.parent.addControl(this);
    this.controls = {};
    this.formData = this.formData || this.getEmptyFormData();
    if ($attrs[this.directiveName]) {
      exp = $parse($attrs[this.directiveName]);
      exp.assign($scope.$parent, this);
    }
    $scope.$on('$destroy', this.$destroy);
  }

  Object.defineProperties(dybSubFormController.prototype, {
    name: {
      get: function() {
        return this.ngForm.$name;
      }
    },
    formData: {
      get: function() {
        return this.parent.getFormData(this);
      },
      set: function(value) {
        this.parent.setFormData(this, value);
      }
    }
  });

  dybSubFormController.prototype.getEmptyFormData = function() {
    var data;
    data = {};
    if (this.subFormId) {
      data['id'] = this.subFormId;
    }
    return data;
  };

  dybSubFormController.prototype.$destroy = function() {
    this.parent.removeControl(this);
  };

  dybSubFormController.prototype.addControl = function(control) {
    this.controls[control.name] = control;
    this[control.name] = control;
  };

  dybSubFormController.prototype.removeControl = function(control) {
    delete this.controls[control.name];
    delete this[control.name];
  };

  dybSubFormController.prototype.getFormData = function(control) {
    var ref;
    return (ref = this.formData) != null ? ref[control.name] : void 0;
  };

  dybSubFormController.prototype.setFormData = function(control, value) {
    this.formData[control.name] = value;
  };

  dybSubFormController.prototype.refreshData = function() {
    var control, name, ref;
    this.formData = this.getEmptyFormData();
    ref = this.controls;
    for (name in ref) {
      if (!hasProp.call(ref, name)) continue;
      control = ref[name];
      control.refreshData();
    }
  };

  return dybSubFormController;

})();

dybFormArrayController = (function(superClass) {
  extend(dybFormArrayController, superClass);

  dybFormArrayController.prototype.directiveName = 'dybFormArray';


  /* @ngInject */

  function dybFormArrayController($scope, $element, $attrs, $parse) {
    this.rebuildItemArray = bind(this.rebuildItemArray, this);
    dybFormArrayController.__super__.constructor.call(this, $scope, $element, $attrs, $parse);
    this.controls = [];
    this.scope = $scope;
    this.deletedItems = [];
    this.createdItems = [];
    this.items = [];
    $scope.$watchCollection("viewArray", this.rebuildItemArray);
  }

  dybFormArrayController.prototype.getEmptyFormData = function() {
    return [];
  };

  dybFormArrayController.prototype.rebuildItemArray = function() {
    var item, j, k, len, len1, ref, ref1;
    this.items = [];
    ref = this.scope.viewArray;
    for (j = 0, len = ref.length; j < len; j++) {
      item = ref[j];
      if (indexOf.call(this.deletedItems, item) < 0) {
        this.items.push(item);
      }
    }
    ref1 = this.createdItems;
    for (k = 0, len1 = ref1.length; k < len1; k++) {
      item = ref1[k];
      this.items.push(item);
    }
  };

  dybFormArrayController.prototype.addControl = function(control) {
    control._nestedIndex = this.controls.length;
    this.controls.push(control);
  };

  dybFormArrayController.prototype.removeControl = function(control) {
    var index;
    index = this.controls.indexOf(control);
    if (index >= 0) {
      this.controls.splice(index, 1);
      this.formData.splice(index, 1);
    }
    this.reindex();
  };

  dybFormArrayController.prototype.reindex = function() {
    var i, item, j, len, ref;
    ref = this.controls;
    for (i = j = 0, len = ref.length; j < len; i = ++j) {
      item = ref[i];
      item._nestedIndex = i;
    }
  };

  dybFormArrayController.prototype.getFormData = function(control) {
    var ref;
    return (ref = this.formData) != null ? ref[control._nestedIndex] : void 0;
  };

  dybFormArrayController.prototype.setFormData = function(control, value) {
    this.formData[control._nestedIndex] = value;
  };

  dybFormArrayController.prototype.refreshData = function() {
    var control, j, len, ref;
    this.deletedItems = [];
    this.createdItems = [];
    this.rebuildItemArray();
    this.formData = this.getEmptyFormData();
    ref = this.controls;
    for (j = 0, len = ref.length; j < len; j++) {
      control = ref[j];
      control.refreshData();
    }
  };

  dybFormArrayController.prototype.add = function(item) {
    this.createdItems.push(item);
    this.rebuildItemArray();
  };

  dybFormArrayController.prototype.openAndAdd = function(item) {
    if (this.dybForm.isOpen) {
      return this.add(item);
    }
    return this.dybForm.open().then((function(_this) {
      return function() {
        return _this.add(item);
      };
    })(this));
  };

  dybFormArrayController.prototype["delete"] = function(item) {
    var index;
    index = this.createdItems.indexOf(item);
    if (index >= 0) {
      this.createdItems.splice(index, 1);
    } else if (indexOf.call(this.deletedItems, item) < 0) {
      this.deletedItems.push(item);
    }
    this.rebuildItemArray();
  };

  return dybFormArrayController;

})(dybSubFormController);

dybFormSortableController = (function(superClass) {
  extend(dybFormSortableController, superClass);

  dybFormSortableController.prototype.directiveName = 'dybFormSortable';


  /* @ngInject */

  function dybFormSortableController($scope, $element, $attrs, $parse) {
    this.swap = bind(this.swap, this);
    this.moveDown = bind(this.moveDown, this);
    this.moveUp = bind(this.moveUp, this);
    this.sortPredicate = bind(this.sortPredicate, this);
    this.getSortValue = bind(this.getSortValue, this);
    dybFormSortableController.__super__.constructor.call(this, $scope, $element, $attrs, $parse);
    this.weightName = $attrs.weightAttribute || 'weight';
  }

  dybFormSortableController.prototype.rebuildItemArray = function() {
    dybFormSortableController.__super__.rebuildItemArray.call(this);
    return this.sortItems();
  };

  dybFormSortableController.prototype.getSortValue = function(item) {
    var data;
    data = this.formData.findId(item.id);
    if (data) {
      return data[this.weightName];
    } else {
      return item[this.weightName];
    }
  };

  dybFormSortableController.prototype.sortPredicate = function(a, b) {
    a = this.getSortValue(a);
    b = this.getSortValue(b);
    return +(a > b) || +(a === b) - 1;
  };

  dybFormSortableController.prototype.sortItems = function() {
    var control, index, item, j, len, ref, results;
    this.items.sort(this.sortPredicate);
    this.formData.sort(this.sortPredicate);
    ref = this.controls;
    results = [];
    for (j = 0, len = ref.length; j < len; j++) {
      control = ref[j];
      item = this.items.findId(control.subFormId);
      index = this.items.indexOf(item);
      results.push(control._nestedIndex = index);
    }
    return results;
  };

  dybFormSortableController.prototype.moveUp = function(item) {
    var data, index;
    data = this.formData.findId(item.id);
    index = this.formData.indexOf(data);
    return this.swap(index, index - 1);
  };

  dybFormSortableController.prototype.moveDown = function(item) {
    var data, index;
    data = this.formData.findId(item.id);
    index = this.formData.indexOf(data);
    return this.swap(index, index + 1);
  };

  dybFormSortableController.prototype.swap = function(fromIndex, toIndex) {
    var cached;
    if (toIndex >= 0 && toIndex < this.formData.length) {
      cached = this.formData[toIndex][this.weightName];
      this.formData[toIndex][this.weightName] = this.formData[fromIndex][this.weightName];
      this.formData[fromIndex][this.weightName] = cached;
      this.sortItems();
    }
  };

  dybFormSortableController.prototype.setFormData = function(control, value) {
    var item;
    dybFormSortableController.__super__.setFormData.call(this, control, value);
    item = this.items.findId(value.id);
    if (item) {
      value[this.weightName] = item[this.weightName];
    }
  };

  dybFormSortableController.prototype.refreshData = function() {
    var control, id, item, j, len, ref;
    dybFormSortableController.__super__.refreshData.call(this);
    ref = this.controls;
    for (j = 0, len = ref.length; j < len; j++) {
      control = ref[j];
      id = control.formData.id;
      item = this.items.findId(id);
      if (item) {
        control.formData[this.weightName] = item[this.weightName];
      }
    }
    return this.sortItems();
  };

  return dybFormSortableController;

})(dybFormArrayController);

module.directive('dybSubForm', function() {
  return {
    restrict: 'A',
    controllerAs: 'ctrl',
    controller: dybSubFormController,
    require: ['^^dybForm', 'ngForm'],
    priority: -1,
    scope: {},
    bindToController: {
      subFormId: '=dybSubFormId'
    }
  };
});

module.directive('dybFormArray', function() {
  return {
    restrict: 'A',
    controllerAs: 'ctrl',
    controller: dybFormArrayController,
    require: ['^^dybForm', 'ngForm'],
    priority: -1,
    scope: {
      viewArray: '=array'
    }
  };
});

module.directive('dybFormSortable', function() {
  return {
    restrict: 'A',
    controllerAs: 'ctrl',
    controller: dybFormSortableController,
    require: ['^^dybForm', 'ngForm'],
    priority: -1,
    scope: {
      viewArray: '=array'
    }
  };
});
})(angular, angular.module("dybForms"));